import { render, staticRenderFns } from "./addPropertyRightRegistration.vue?vue&type=template&id=010317cd&scoped=true"
import script from "./addPropertyRightRegistration.vue?vue&type=script&lang=js"
export * from "./addPropertyRightRegistration.vue?vue&type=script&lang=js"
import style0 from "./addPropertyRightRegistration.vue?vue&type=style&index=0&id=010317cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010317cd",
  null
  
)

export default component.exports